export default __webpack_public_path__ + "static/media/rihem.39dffe91.png";